/* eslint-disable @typescript-eslint/ban-ts-comment */
export const addClass = (el: HTMLElement, className: string) => {
    el.classList.add(className);
};

export const removeClass = (el: HTMLElement, className: string) => {
    el.classList.remove(className);
};

export const hasClass = (el: HTMLElement, className: string) => {
    return el.classList.contains(className);
};

export const toggleClass = (el: HTMLElement, className: string) => {
    return el.classList.toggle(className);
};
